var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchNotAccepted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.410645C4.64844 0.410645 0.3125 4.74658 0.3125 10.0981C0.3125 15.4497 4.64844 19.7856 10 19.7856C15.3516 19.7856 19.6875 15.4497 19.6875 10.0981C19.6875 4.74658 15.3516 0.410645 10 0.410645ZM4.84375 11.6606C4.58594 11.6606 4.375 11.4497 4.375 11.1919V9.00439C4.375 8.74658 4.58594 8.53564 4.84375 8.53564H15.1562C15.4141 8.53564 15.625 8.74658 15.625 9.00439V11.1919C15.625 11.4497 15.4141 11.6606 15.1562 11.6606H4.84375Z",
    fill: "#DF2929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNotAccepted);
export default __webpack_public_path__ + "static/media/search_not_accepted.e59016a496bd4f7b69b6c000302d62b2.svg";
export { ForwardRef as ReactComponent };